module.exports = __webpack_public_path__ + "static/gold-medal-gin-8586d54a6ccaf62affc6da9bf97ca081.jpg";